import { render, staticRenderFns } from "./type.vue?vue&type=template&id=552f1750&scoped=true"
import script from "./type.vue?vue&type=script&lang=js"
export * from "./type.vue?vue&type=script&lang=js"
import style0 from "./type.vue?vue&type=style&index=0&id=552f1750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "552f1750",
  null
  
)

export default component.exports